import { Box, Typography, Paper } from '@mui/material';
import React from 'react';

const assetStyle = {
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center",
    justifyContent: "space-between",
    width: "14rem", 
    minHeight: "20rem", 
    p: 4
}

export default function TopicTile(props) {

    return(
        <Paper sx={assetStyle}>
            <Box sx={{display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", height: "100%"}}>

                <Box sx={{pl: 4, pr: 4}}>
                    <img src={props.img} alt={"Image for " + props.title} height="200px" style={{maxWidth: "240px"}}/>
                </Box>
                <Box sx={{mt: 1}}>
                    <Typography align="center" variant="body2">{props.title}</Typography>
                </Box>
            </Box>
        </Paper>
    )
}